export const upperCaseCountryCode = (locale: string): string => {
  const arr = locale.split('-');
  arr[1] = arr[1].toUpperCase();

  return arr[0] + '-' + arr[1];
};
